var map = {
	"./display.png": 842,
	"./display/dashboard.png": 139,
	"./display/landingspage.png": 28,
	"./display/videowatch.png": 22,
	"./pokemon.png": 978,
	"./pokemon/challenger-arrived.png": 23,
	"./pokemon/change-pokemon.png": 192,
	"./pokemon/choose.png": 812,
	"./pokemon/start.png": 776,
	"./record-tracker.png": 398,
	"./recordtracker/dashboard.png": 507,
	"./recordtracker/record-view.png": 212,
	"./recordtracker/search-window.png": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 660;